import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import "./index.css"
import './output.css';
import "./scss/style.scss";
import { DialogProvider } from './utils/DialogContext';
import useSubscriptionCheck from './utils/useSubscriptionCheck';
import ProjectDetail from './views/projectdetails/ProjectDetails';
import RouteGuard from './utils/RouteGuard';
import mixpanel from "mixpanel-browser";
import { PusherProvider } from './utils/PusherProvider';

// Initialize Mixpanel before rendering your app
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers.
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page403 = React.lazy(() => import('./views/pages/page403/Page403'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
const Forgot = React.lazy(() => import('./views/pages/forgotpassword/Forgot'));
const CompanyProfile = React.lazy(() => import('./views/company-profile/CompanyProfile'));
const ResetPassword = React.lazy(() => import('./views/pages/resetpassword/ResetPassword'));
const PaymentSuccess = React.lazy(() => import('./views/subscription/payment/PaymentSuccess'));
const PaymentFailed = React.lazy(() => import('./views/subscription/payment/PaymentFailed'));
const GovPortal = React.lazy(() => import('./views/gov-portal/GovPortal'));
class App extends Component {
  render() {
    return (
      <HashRouter>
        <RouteGuard>
          <PusherProvider>
            <DialogProvider>
              <AppWrapper />
            </DialogProvider>
          </PusherProvider>
        </RouteGuard>
      </HashRouter>
    );
  }
}

const AppWrapper = () => {
  useSubscriptionCheck();
  return (
    <React.Suspense fallback={loading}>
      <Switch>
        <Route exact path="/" name="Login Page" render={(props) => <Login {...props} />} />
        <Route exact path="/register" name="Register Page" render={(props) => <Register {...props} />} />
        <Route exact path="/403" name="Page 403" render={(props) => <Page403 {...props} />} />
        <Route exact path="/404" name="Page 404" render={(props) => <Page404 {...props} />} />
        <Route exact path="/500" name="Page 500" render={(props) => <Page500 {...props} />} />
        <Route exact path="/Forgot" name="Forgot Password" render={(props) => <Forgot {...props} />} />
        <Route path="/payment/success" name="Success Payment" render={(props) => <PaymentSuccess {...props} />} />
        <Route path="/payment/failed" name="Success Payment" render={(props) => <PaymentFailed {...props} />} />
        <Route path="/company-profile" name="CompanyProfile" render={(props) => <CompanyProfile {...props} />} />
        <Route path="/reset-password/:token" name="ResetPassword" render={(props) => <ResetPassword {...props} />} />
        <Route path="/projects/:id/scopeofwork" component={ProjectDetail} />
        <Route exact path="/gov-portal/:regionSlug?" name="Government Portal" render={(props) => <GovPortal {...props} />} />
        <Route path="/" render={(props) => <TheLayout {...props} />} />
      </Switch>
    </React.Suspense>
  );
};
export default App;
